
export const api = {
  async get(endpoint: string) {
    const token = localStorage.getItem('clevercubby_token');
    const res = await fetch(`/api${endpoint}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },

  async post(endpoint: string, body: any) {
    const token = localStorage.getItem('clevercubby_token');
    const headers: any = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const res = await fetch(`/api${endpoint}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body)
    });

    // Parse JSON if content exists
    const text = await res.text();
    if (!res.ok) {
      try {
        const errData = JSON.parse(text);
        const error = new Error(errData.message || text);
        (error as any).data = errData;
        (error as any).status = res.status;
        throw error;
      } catch (e) {
        // If it was already our custom error, rethrow it
        if ((e as any).data) throw e;
        // Otherwise it was a JSON parse error or other error
        throw new Error(text);
      }
    }
    return text ? JSON.parse(text) : {};
  },

  async patch(endpoint: string, body: any) {
    const token = localStorage.getItem('clevercubby_token');
    const headers: any = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const res = await fetch(`/api${endpoint}`, {
      method: 'PATCH',
      headers,
      body: JSON.stringify(body)
    });

    const text = await res.text();
    if (!res.ok) {
      try {
        const errData = JSON.parse(text);
        const error = new Error(errData.message || text);
        (error as any).data = errData;
        (error as any).status = res.status;
        throw error;
      } catch (e) {
        // If it was already our custom error, rethrow it
        if ((e as any).data) throw e;
        // Otherwise it was a JSON parse error or other error
        throw new Error(text);
      }
    }
    return text ? JSON.parse(text) : {};
  },

  async delete(endpoint: string) {
    const token = localStorage.getItem('clevercubby_token');
    const res = await fetch(`/api${endpoint}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const text = await res.text();
    if (!res.ok) {
      try {
        const errData = JSON.parse(text);
        const error = new Error(errData.message || text);
        (error as any).data = errData;
        (error as any).status = res.status;
        throw error;
      } catch (e) {
        // If it was already our custom error, rethrow it
        if ((e as any).data) throw e;
        // Otherwise it was a JSON parse error or other error
        throw new Error(text);
      }
    }
    return text ? JSON.parse(text) : {};
  }
};
